module.exports = __webpack_public_path__ + "img/formulir-logo-white.e52431cb.svg";